import React from "react";
import {
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import DetailedJobStore from "../store/DetailedJobReportStore";
import DriverLoginReportStore from "../store/DriverLoginReportStore";
import DailyJobReportStore from "../store/DailyJobReportStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";

const { RangePicker } = DatePicker;
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};
const { Option } = Select;
class DailyJobReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    // this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.vehicleStore = new VehicleStore();
    this.detailedJobReportStore = new DetailedJobStore(this);
    this.driverLoginStore = new DriverLoginReportStore(this);
    this.dailyJobReportStore = new DailyJobReportStore(this);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectedDrivers: [],
      selectAllVehicles: false,
      selectAllDrivers: false,
      showMonthPopup: false,
      filterby: "",
      data: "",
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      Notcompany: false,
      Notasset: false,
      NotDriver: false,
      filterNotSelected: false,
      expandedRowKeys: [],
      loadedInvoiceData: {},
      selectAllStatus: false,
      status: "",
      innerGridData: [],
      filterValue: "",
      modalVisible: false,

      selectedColumns: widthAdderFunc([
        {
          title: context.translate("Sr No."),
          dataIndex: "sno",
          key: "sno",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_VEHICLE_NO_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_DRIVER_ID_"),
          dataIndex: "driverId",
          key: "driverId",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate(
            "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
          ),
          dataIndex: "name",
          key: "name",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_INVOICE_NO_"),
          dataIndex: "invoiceNo",
          key: "invoiceNo",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_DEPOSITOR_"),
          dataIndex: "depositor",
          key: "depositor",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_INVOICE_AMOUNT_"),
          dataIndex: "invoiceAmount",
          key: "invoiceAmount",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_QUANTITY_"),
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_CUSTOMER_NAME_"),
          dataIndex: "customerName",
          key: "customerName",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_DELIVERY_STATUS_"),
          dataIndex: "deliveryStatus",
          key: "deliveryStatus",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_UNDELIVERED_REASON_"),
          dataIndex: "orderStatus",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_JOB_STARTED_TIME_"),
          dataIndex: "jobStartedTime",
          key: "jobStartedTime",
          width: 100,
          ellipsis: { showTitle: true },
        },

        {
          title: context.translate("_JOB_FINISHED_TIME_"),
          dataIndex: "jobFinishedTime",
          key: "jobFinishedTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_FLEET_CREATEROUTE_ROUTEADD_TOTALTIME_"),
          dataIndex: "totalduration",
          key: "totalduration",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_TRAVEL_KM_"),
          dataIndex: "travelKm",
          key: "travelKm",
          width: 100,
          ellipsis: { showTitle: true },
        },

        {
          title: context.translate("_NO_OF_ATTEMPTS_"),
          dataIndex: "attempt_number",
          width: 100,
          ellipsis: { showTitle: true },
        },
      ]),
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            filterBy: this.state.filterby,
            driverId: this.state.selectedDrivers,
            status: this.state.status,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            language: null,
          };
          if (val.key == "excel") {
            this.dailyJobReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.dailyJobReportStore.exportpdf(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedDrivers: [],
      selectAllDrivers: false,
    });

    await this.vehicleStore.getDeliveryVehicles(comp?.value);

    await this.driverLoginStore.getDriversByCompanyId({
      companyId: comp?.value,
    });

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.selectedDrivers.length === 0) {
      this.setState({ NotDriver: true });
    } else {
      this.setState({ NotDriver: false });
    }
    if (this.state.filterValue.length === 0) {
      console.log("filterValue");
      this.setState({ filterNotSelected: true });
    } else {
      this.setState({ filterNotSelected: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }
    if (
      ((this.state.companyId &&
        this.state.filterValue.length > 0 &&
        this.state.selectedDrivers.length > 0) ||
        (this.state.companyId &&
          this.state.filterValue.length > 0 &&
          this.state.selectedVehicles.length > 0)) &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      this.setState({
        Notcompany: false,
        Notasset: false,
        NotDriver: false,
        filterNotSelected: false,
      });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.dailyJobReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          filterBy: this.state.filterby,
          vehicleId: this.state.selectedVehicles,
          driverId: this.state.selectedDrivers,
          status: this.state.status,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId?.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleAllSelectDriver = async (e) => {
    if (this.state.selectAllDrivers) {
      const allDrivers = this.driverLoginStore?.getDrivers?.map((val) => {
        return val.driverId;
      });
      await this.setState({ selectedDrivers: allDrivers });
    } else {
      await this.setState({ selectedDrivers: [] });
    }
  };

  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  className="searchInput"
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <>
                    <DeviceGroupsForVehicles
                      vehicleStore={this.vehicleStore}
                      setLoadDta={() => this.setState({ loadData: 1 })}
                      resetVehicles={() =>
                        this.setState({
                          selectedVehicles: [],
                          selectAllVehicles: false,
                        })
                      }
                    />
                  </>
                )}

                <Select
                  style={{ width: 130 }}
                  className="searchInput"
                  status={this.state.filterNotSelected ? "error" : false}
                  // placeholder='Filter by'
                  placeholder={this.context.translate("_FILTER_BY_")}
                  onChange={(val) => {
                    this.setState({ filterValue: val });
                    this.setState({
                      filterby: val,
                      selectedDrivers: [],
                      selectedVehicles: [],
                      selectAllDrivers: false,
                      selectAllVehicles: false,
                    });
                  }}
                >
                  <Select.Option value="Driver">
                    {this.context.translate(
                      "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
                    )}
                  </Select.Option>

                  <Select.Option value="Vehicle">
                    {this.context.translate("_VEHICLES_")}
                  </Select.Option>
                </Select>
                {this.state.filterby == "Vehicle" && (
                  <>
                    <Checkbox
                      checked={this.state.selectAllVehicles}
                      onChange={async (e) => {
                        await this.setState({
                          selectAllVehicles: e.target.checked,
                        });
                        if (this.state.selectAllVehicles) {
                          await this.setState({
                            Notasset: false,
                          });
                        }
                        await this.handleAllSelectVehicles();
                      }}
                    />

                    {this.context.translate("_ALL_")}

                    <Select
                      maxTagCount="responsive"
                      className="searchInput"
                      value={this.state.selectedVehicles}
                      onChange={(val) => {
                        this.setState({ selectedVehicles: val });
                        if (
                          this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                          val.length
                        ) {
                          this.setState({ selectAllVehicles: false });
                        } else {
                          this.setState({ selectAllVehicles: true });
                        }

                        if (val?.length > 1) {
                          this.setState({ showAlertPopup: true });
                        }
                      }}
                      style={{ width: 180 }}
                      showSearch
                      status={this.state.Notasset ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                        (val) => {
                          return (
                            <Option value={val.vehicleId}>
                              {val.vehicleNo}
                            </Option>
                          );
                        }
                      )}
                    </Select>
                  </>
                )}
                {this.state.filterby == "Driver" && (
                  <>
                    <Checkbox
                      checked={this.state.selectAllDrivers}
                      onChange={async (e) => {
                        await this.setState({
                          selectAllDrivers: e.target.checked,
                        });

                        await this.handleAllSelectDriver();
                      }}
                    />

                    {this.context.translate("_ALL_")}
                    <Select
                      maxTagCount="responsive"
                      className="searchInput"
                      value={this.state.selectedDrivers}
                      onChange={(val) => {
                        this.setState({ selectedDrivers: val });
                        if (
                          this.driverLoginStore?.getDrivers?.length > val.length
                        ) {
                          this.setState({ selectAllDrivers: false });
                        } else {
                          this.setState({ selectAllDrivers: true });
                        }
                      }}
                      style={{ width: 180 }}
                      showSearch
                      status={this.state.NotDriver ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_FLEET_DRIVER_DRIVERLIST_DRIVERNAME_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.driverLoginStore?.getDrivers?.map((val) => {
                        return <Option value={val.driverId}>{val.name}</Option>;
                      })}
                    </Select>
                  </>
                )}

                <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [
                      dayjs().startOf("day"),
                      dayjs().endOf("day"),
                    ],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                  status={this.state.Notdate ? "error" : false}
                />

                <Select
                  allowClear={true}
                  placeholder={this.context.translate("_STATUS_")}
                  className="searchInput"
                  style={{ width: 130 }}
                  onChange={async (val) => {
                    await this.setState({ status: val });
                    await this.dailyJobReportStore.loadData({
                      offset: 0,
                      limit: this.state.pageSize,
                      companyId: this.state.companyId,
                      filterBy: this.state.filterby,
                      vehicleId: this.state.selectedVehicles,
                      driverId: this.state.selectedDrivers,
                      status: val,
                      fromDate: this.state.fromDate,
                      toDate: this.state.toDate,
                      pageNo: this.state.currentPage,
                    });
                    await this.setState({ pageSize: 50, currentPage: 1 });
                    this.setState({ loading: false });
                  }}
                  options={[
                    {
                      label: "All",
                      value: "",
                    },
                    {
                      label: "Delivered",
                      value: "3",
                    },
                    {
                      label: "Pending",
                      value: "9",
                    },
                    {
                      label: "Cancelled",
                      value: "4",
                    },
                  ]}
                />

                <Button
                  type="primary"
                  onClick={async () => {
                    await this.setState({ pageSize: 50, currentPage: 1 });
                    await this.showData();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.dailyJobReportStore?.detailedJobData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            key={this.state.selectedColumns.length}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.dailyJobReportStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.dailyJobReportStore?.detailedJobData}
            loading={this.dailyJobReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
      </>
    );
  }
}
DailyJobReport.contextType = StoreContext;
export default observer(withRouter(DailyJobReport));
